<table mat-table [dataSource]="usersDataSource" matSort matSortActive="username" matSortDirection="asc"
    (matSortChange)="announceSortChange($event)">
    <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Username</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border"> {{user.username}} </td>
    </ng-container>
    <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">First name</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border"> {{user.firstname}} </td>
    </ng-container>
    <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Last name</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border"> {{user.lastname}} </td>
    </ng-container>
    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Email</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border"> {{user.email}} </td>
    </ng-container>
    <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef class="r-th">Roles</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border">
            {{user.roles.join(', ')}} </td>
    </ng-container>
    <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-th">Enabled?</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border">
            @if (user.enabled) {
            <mat-icon color="primary" style="color: green" title="Enabled">check_circle</mat-icon>
            } @else {
            <mat-icon color="warn" style="color: red;" title="Disabled">cancel</mat-icon>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="r-th">Actions</th>
        <td mat-cell *matCellDef="let user" class="r-no-bottom-border">
            <button mat-icon-button color="primary" title="Edit user" (click)="editUser(user)">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button [color]="user.enabled ? 'warn' : 'primary'"
                [title]="user.enabled ? 'Disable user' : 'Enable user'" (click)="toggleUser(user)">
                <mat-icon>{{user.enabled ? 'block' : 'check_circle'}}</mat-icon>
            </button>
            <button mat-icon-button color="warn" title="Delete user" (click)="deleteUser(user)">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="7">No data available</td>
    </tr>
</table>

<mat-paginator #userPaginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="showFirstLastButtons">
</mat-paginator>

<div
    style="display: flex; flex-direction: row; justify-content: center; gap: 10px; padding-top: 10px; padding-bottom: 10px;">
    <button matFab extended color="primary" title="Add a user" (click)="addUser()">
        <mat-icon>add</mat-icon>Add user
    </button>
</div>
